import { memo, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLiveStreamAppContext } from "../ContextStore/Store";
import { getDeviceInfoDetails } from "../utils/PlatformCheck";
import axios from "axios";
import { AmplitudeAddLog } from "../utils/AppAmplitude";

function FeedbackAttendee() {
  const [audioRating, setAudioRating] = useState();
  const [videoRating, setVideoRating] = useState();
  const [textFeedback, setTextFeedback] = useState("");
  const [hoveredAudioRating, setHoveredAudioRating] = useState(0);
  const [hoveredVideoRating, setHoveredVideoRating] = useState(0);
  const navigate = useNavigate();
  const {
    __merchantId,
    __userId,
    appInsightTrack,
    __appConfirmUniqueID,
    setInformationContent,
    setShowInformationStrip,
    role,
    apiUrlPost,
    grp,
    businessURL,
    setBusinessURL
  } = useLiveStreamAppContext();
  const deviceInfoDetails = getDeviceInfoDetails();

  const roleValue =
    role === "Attendee" ? "a" : role === "Presenter" ? "h" : role;
  const reJoinUrl =
    "/livestream/meeting?aid=" +
    __appConfirmUniqueID +
    "&mid=" +
    __merchantId +
    "&uid=" +
    __userId +
    "&role=" +
    roleValue +
    "&grp=" + grp;

  const headers = {
    "Content-Type": "application/json",
    userId: __userId,
    merchantId: __merchantId,
  };

  //useEffect for handling Session End
  useEffect(() => {
    sessionStorage.setItem("end", 1)
  }, [])

  //Function for Handling Rating Stars on Click
  const handleRatingClick = (type, rating) => {
    if (type === "video") {
      setVideoRating(rating);
      setHoveredVideoRating(0);
    } else if (type === "audio") {
      setAudioRating(rating);
      setHoveredAudioRating(0);
    }
  };
  const handleMouseOver = (type, rating) => {
    if (type === "video") {
      setHoveredVideoRating(rating);
    } else if (type === "audio") {
      setHoveredAudioRating(rating);
    }
  };
  const handleMouseOut = (type) => {
    if (type === "video") {
      setHoveredVideoRating(0);
    } else if (type === "audio") {
      setHoveredAudioRating(0);
    }
  };

  //Function to Validate Feedback attributes and Call Feedback Api
  const leaveFeedback = () => {
    if (!audioRating || !videoRating) {
      setShowInformationStrip(true);
      setInformationContent({
        type: 'warn',
        message: 'All reviews are mandatory.',
      });
      return;
    }

    let trimmedtextFeedback = textFeedback.trim();
    if ((audioRating <= 3 || videoRating <= 3) && trimmedtextFeedback.length < 20) {
      setShowInformationStrip(true);
      setInformationContent({
        type: 'warn',
        message: 'Required Minimum 20 Characters.'
      })
      return;
    }

    let sendFeedback = document.getElementById("leaveFeedback");
    sendFeedback.classList.add("divDisabled");

    const payload = {
      attendeeType: 1,
      rnkVideo: videoRating,
      rnkAudio: audioRating,
      deviceInfoDetails: deviceInfoDetails,
      appConfirmUniqueId: __appConfirmUniqueID,
      qualityFeedback: textFeedback,
    };
    const feedbackinitialize = async () => {
      try {
        const feedbackResponse = await axios.post(
          `${apiUrlPost}managelivestreamfeedback`,
          payload, { headers }
        );
        // Dispose or reset sensitive data after use
        payload.attendeeType = null;
        payload.rnkVideo = null;
        payload.rnkAudio = null;
        payload.deviceInfoDetails = null;
        payload.qualityFeedback = null;

        if (feedbackResponse.data.data.isSuccess === true) {
          const vagaroURL = feedbackResponse.data.data.vagaroURL;
          setBusinessURL(vagaroURL);
          const currentPath = window.location.pathname;
          const newPath = currentPath.replace("/feedback", "/review");
          navigate(newPath + window.location.search);
        }
      } catch (error) {
        if (error.status === 400 || error.status === 500) {
          console.error(error.message);
          setShowInformationStrip(true);
          setInformationContent({
            type: 'alert',
            message: error.message,
          });
        }
        console.error("Error in fetching feedback response:", error);
        appInsightTrack(__merchantId, __userId, "Feedback Attendee", "", error);
      }
    };
    feedbackinitialize().then(() => {
      sendFeedback.classList.remove("divDisabled");
    });
  };

  const handleRejoinClick = () => {
    if (navigator.userAgent.indexOf("com.vagaro.customerios") > -1) {
      navigate("/livestream/rejoindismiss");
    } else {
      navigate(reJoinUrl);
      sessionStorage.removeItem("end");
      window.location.reload();
    }
  }

  useEffect(() => {
    AmplitudeAddLog(__userId, __merchantId, businessURL, 110, grp, __appConfirmUniqueID);
  }, [__userId])

  return (
    <div
      className="host-review"
      style={{ display: "flex" }}
    >
      <div
        id="btnRejoinLivestream"
        className="top-header rejoin-btn-top rejoin-mob-view host-rejoin"
      >
        <button
          className="btn btn-outline-cream btn-rejoin rejoin-btn"
          title="Rejoin Livestream"
          onClick={handleRejoinClick}
        >
          Rejoin Livestream
        </button>
      </div>
      <div className="host-review-wrapper">

        <div className="center-Review-Screen no-wrap">
          <div className="review-center-box">
            <h5 className="review-title">How Was The Live Stream?</h5>
            <div className="rating-dives">
              <div className="stars">
                <div className="your-review-title">Video Quality:</div>
                <div className="font-size24">
                  <div className="review-rating" id="dv-videoqualityhost">
                    {[1, 2, 3, 4, 5].map((value) => (
                      <div
                        key={value}
                        className={`rating-symbol glyphicon glyphicon-star ${videoRating >= value || hoveredVideoRating >= value
                          ? "rating-symbol"
                          : "glyphicon-star-empty"
                          }`}
                        onMouseOut={() => handleMouseOut("video")}
                        onMouseOver={() => handleMouseOver("video", value)}
                        onClick={() => handleRatingClick("video", value)}
                      ></div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="stars">
                <div className="your-review-title audioQualityTitle">Audio Quality:</div>
                <div className="font-size24">
                  <div className="review-rating" id="dv-audioquality">
                    {[1, 2, 3, 4, 5].map((value) => (
                      <div
                        key={value}
                        className={`rating-symbol glyphicon glyphicon-star ${audioRating >= value || hoveredAudioRating >= value
                          ? "rating-symbol"
                          : "glyphicon-star-empty"
                          }`}
                        onMouseOut={() => handleMouseOut("audio")}
                        onMouseOver={() => handleMouseOver("audio", value)}
                        onClick={() => handleRatingClick("audio", value)}
                      ></div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="host-Imp">
              <div
                className="lbl-TxtArea"
                style={{
                  display: audioRating < 4 || videoRating < 4 ? "block" : "none",
                }}
              >
                <div className="rightReviewCountText">
                  <span>{textFeedback.length}</span>/500
                </div>
                <label className="field-label spname lt-text">
                  Additional feedback:
                </label>
                <textarea
                  className="review-text-field w-input inputfixscroll bg-Txt t-height"
                  placeholder="What can be improved?"
                  maxLength="500"
                  value={textFeedback}
                  onChange={(e) => setTextFeedback(e.target.value)}
                ></textarea>
              </div>
            </div>
          </div>
        </div>
        <div className="ft-btn fullwidthbtn">
          <button id="leaveFeedback" className="cbtn thm-btn send-feedback" onClick={leaveFeedback}>
            <span>Leave Feedback</span>
          </button>
        </div>
      </div>
    </div>
  );
}
export default memo(FeedbackAttendee);